import { pickBy, forIn, assignIn } from 'lodash';

export const templates = ({ templates }) => templates.byId;

export const template = ({ templates }, { templateId }) =>
  templates.byId[templateId];

export const swappedTemplate = ({ templates }) => {
  if (templates.swappedTemplateId) {
    return templates.byId[templates.swappedTemplateId];
  }
};

export const charmsForTemplate = ({ templates }, { templateId }) => {
  const template = templates.byId[templateId];
  const charms = template.charms || [];
  return charms;
};

export const designPackageForTemplate = (
  {
    templates,
    paints,
    interiors,
    trims,
    wheels,
    colorLines,
    roofAndMirrorCaps,
    dashboard,
  },
  { templateId },
) => {
  const {
    paintOption,
    interiorOption,
    trimOption,
    wheelOption,
    roofAndMirrorCapOption,
    colorLineOption,
    imgUrls,
  } = templates.byId[templateId].designPackage;
  let optionKeys = Object.keys(
    templates.byId[templateId].designPackage,
  ).filter(key => key.includes('Option'));

  return {
    paintOption: paintOption
      ? Object.assign({}, paintOption, paints.byId[paintOption.id])
      : null,
    interiorOption: interiorOption
      ? Object.assign({}, interiorOption, interiors.byId[interiorOption.id])
      : null,
    trimOption: trimOption
      ? Object.assign({}, trimOption, trims.byId[trimOption.id])
      : null,
    wheelOption: wheelOption
      ? Object.assign({}, wheelOption, wheels.byId[wheelOption.id])
      : null,
    roofAndMirrorCapOption: roofAndMirrorCapOption
      ? Object.assign(
          {},
          roofAndMirrorCapOption,
          roofAndMirrorCaps.byId[roofAndMirrorCapOption.id],
        )
      : null,
    colorLineOption: colorLineOption
      ? Object.assign({}, colorLineOption, colorLines.byId[colorLineOption.id])
      : null,
    imgUrls,
    optionKeys,
  };
};

export const miniDesignOptionKeys = ({ templates }, { templateId }) => {
  let currentTemplateId = templates.swappedTemplateId
    ? templates.swappedTemplateId
    : templateId;
  let optionKeys = Object.keys(
    templates.byId[currentTemplateId].designPackage,
  ).filter(key => key.includes('Option'));
  return optionKeys;
};

export const functionalGroupTemplates = (
  { templates, paints, interiors, trims, wheels, roofAndMirrorCaps },
  { templateId },
) => {
  let template = templates.byId[templateId];
  let functionalGroupTemplates = pickBy(templates.byId, t => {
    return t.functionalGroupId === template.functionalGroupId;
  });
  forIn(functionalGroupTemplates, fgt => {
    let {
      paintOption,
      interiorOption,
      trimOption,
      wheelOption,
      roofAndMirrorCapOption,
    } = fgt.designPackage;
    let result = {
      id: fgt.id,
      paintOption: paintOption
        ? { ...paintOption, ...paints.byId[paintOption.id] }
        : null,
      interiorOption: interiorOption
        ? { ...interiorOption, ...interiors.byId[interiorOption.id] }
        : null,
      trimOption: trimOption
        ? { ...trimOption, ...trims.byId[trimOption.id] }
        : null,
      wheelOption: wheelOption
        ? { ...wheelOption, ...wheels.byId[wheelOption.id] }
        : null,
      roofAndMirrorCapOption: roofAndMirrorCapOption
        ? {
            ...roofAndMirrorCapOption,
            ...roofAndMirrorCaps.byId[roofAndMirrorCapOption.id],
          }
        : null,
    };
    assignIn(fgt, result);
  });
  return functionalGroupTemplates;
};

export const modelRemainingQuota = ({ models, templates }, { templateId }) => {
  return (
    templates.byId[templateId] &&
    models.byId[templates.byId[templateId].modelId].remainingQuota
  );
};

// Todo do we need modelWorkingState in quantity / priority selectors?

export const templateQuantity = ({ templatesWorkingState }, { templateId }) => {
  let quantity = 0;
  if (templatesWorkingState.byId[templateId]) {
    quantity = Object.values(
      templatesWorkingState.byId[templateId].prioritiesToQuantitiesMap,
    ).reduce(
      (total, currentQuantity) => total + parseInt(currentQuantity, 10),
      0,
    );
  }
  return quantity;
};

export const submittedTemplateQuantity = (
  { templatesSubmitted },
  { templateId },
) => {
  let quantity = 0;
  if (templatesSubmitted.byId[templateId]) {
    quantity = Object.values(
      templatesSubmitted.byId[templateId].prioritiesToQuantitiesMap,
    ).reduce(
      (total, currentQuantity) => total + parseInt(currentQuantity, 10),
      0,
    );
  }
  return quantity;
};

export const templatePriority = ({ templatesWorkingState }, { templateId }) => {
  let selectedPriority = 'n/a';
  if (templatesWorkingState.byId[templateId]) {
    const mappings =
      templatesWorkingState.byId[templateId].prioritiesToQuantitiesMap;
    const prioritiesWithQuantity = [];
    for (let priority in mappings) {
      if (parseInt(mappings[priority], 10) > 0) {
        prioritiesWithQuantity.push(priority);
      }
    }
    if (prioritiesWithQuantity.length === 0) {
      selectedPriority = 'n/a';
    } else if (prioritiesWithQuantity.length === 1) {
      selectedPriority = prioritiesWithQuantity[0];
    } else if (prioritiesWithQuantity.length > 1) {
      selectedPriority = 'Multiple';
    }
    return selectedPriority;
  }
  return selectedPriority;
};

export const submittedTemplatePriority = (
  { templatesSubmitted },
  { templateId },
) => {
  let priority;
  if (templatesSubmitted.byId[templateId]) {
    const mappings =
      templatesSubmitted.byId[templateId].prioritiesToQuantitiesMap;
    const prioritiesWithQuantity = [];
    for (let priority in mappings) {
      if (parseInt(mappings[priority], 10) > 0) {
        prioritiesWithQuantity.push(priority);
      }
    }
    priority =
      prioritiesWithQuantity.length === 1
        ? prioritiesWithQuantity[0]
        : 'Multiple';
  }
  return priority;
};

export const templatePriorities = (
  { templatesWorkingState },
  { templateId },
) => {
  if (templatesWorkingState.byId[templateId]) {
    return {
      prioritiesQuantities:
        templatesWorkingState.byId[templateId].prioritiesToQuantitiesMap,
    };
  }
  return {
    prioritiesQuantities: {},
  };
};

export const templateStatus = ({ templatesWorkingState }, { templateId }) => {
  const templateState = templatesWorkingState.byId[templateId];
  if (templateState) {
    return templateState.status;
  } else {
    return null;
  }
};

export const hasMultiplePriorities = (
  { templatesWorkingState },
  { templateId },
) => {
  const templateState = templatesWorkingState.byId[templateId];
  if (templateState) {
    return (
      Object.values(templateState.prioritiesToQuantitiesMap).filter(
        quantity => quantity > 0,
      ).length > 1
    );
  } else {
    return null;
  }
};

export const selectedTemplateId = ({ templates }) =>
  templates.selectedTemplateId;

export const duplicateTemplateId = ({ templates }) =>
  templates.duplicateTemplateId;

export const swappedTemplateId = ({ templates }) => templates.swappedTemplateId;
